import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr1005',
    ecrans: ['00-2'],
    params: ['?faccleint']
});
